import './trailingSlash.js'
import './acme-extension.css'
import { initSiteHeader } from './siteHeader'
import { initSiteFooter } from './siteFooter'

initSiteHeader()
initSiteFooter()
